import { TranslatedText } from "@/components/common/text";
import { Paragraph, Title, Subtitle } from "@/components/privacyPolicy";

export const PrivacyPolicy = () => {
    return (
        <div className="flex flex-col text-base/[25px] text-cm-p-text-primary w-full xl:w-[calc(100%-300px)] mx-auto mt-9">
            <h1 className="text-2xl/[38px] font-medium">
                <TranslatedText>Privacy Policy</TranslatedText>
            </h1>
            <p className="mt-6 mb-10 font-semibold">
                <TranslatedText>Last updated</TranslatedText>: <TranslatedText>April</TranslatedText> 2025
            </p>
            <Paragraph>
                This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You
                use the Service and tells You about Your privacy rights and how the law protects You.
            </Paragraph>
            <Paragraph>
                We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of
                information in accordance with this Privacy Policy.
            </Paragraph>
            <Title>Interpretation and Definitions</Title>
            <Subtitle>Interpretation</Subtitle>
            <Paragraph>
                The words of which the initial letter is capitalized have meanings defined under the following conditions. The following
                definitions shall have the same meaning regardless of whether they appear in singular or in plural.
            </Paragraph>
            <Subtitle>Definitions</Subtitle>
            <Paragraph>For the purposes of this Privacy Policy:</Paragraph>
            <Paragraph>Account means a unique account created for You to access our Service or parts of our Service.</Paragraph>
            <Paragraph>
                Affiliate means an entity that controls, is controlled by or is under common control with a party, where "control" means
                ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or
                other managing authority.
            </Paragraph>
            <Paragraph>Application refers to CARGOMINDS, the software program provided by the Company.</Paragraph>
            <Paragraph>
                Business, for the purpose of CCPA/CPRA, refers to the Company as the legal entity that collects Consumers' personal
                information and determines the purposes and means of the processing of Consumers' personal information, or on behalf of
                which such information is collected and that alone, or jointly with others, determines the purposes and means of the
                processing of consumers' personal information, that does business in the State of California.
            </Paragraph>
            <Paragraph>
                CCPA and/or CPRA refers to California Consumer Privacy Act (the "CCPA") as amended by the California Privacy Rights Act of
                2020 (the "CPRA").
            </Paragraph>
            <Paragraph>
                Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to CARGOMINDS R&D CENTER DOO
                KRAGUJEVAC, Dragoslava Srejovića br. 25, Serbia
            </Paragraph>
            <Paragraph>
                Consumer, for the purpose of the CCPA/CPRA, means a natural person who is a California resident. A resident, as defined in
                the law, includes (1) every individual who is in the USA for other than a temporary or transitory purpose, and (2) every
                individual who is domiciled in the USA who is outside the USA for a temporary or transitory purpose.
            </Paragraph>
            <Paragraph>
                Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the
                details of Your browsing history on that website among its many uses.
            </Paragraph>
            <Paragraph>Country refers to: Illinois, United States</Paragraph>
            <Paragraph>Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.</Paragraph>
            <Paragraph>
                Do Not Track (DNT) is a concept that has been promoted by US regulatory authorities, in particular the U.S. Federal Trade
                Commission (FTC), for the Internet industry to develop and implement a mechanism for allowing internet users to control the
                tracking of their online activities across websites.
            </Paragraph>
            <Paragraph>Personal Data is any information that relates to an identified or identifiable individual.</Paragraph>
            <Paragraph>
                For the purposes of the CCPA/CPRA, Personal Data means any information that identifies, relates to, describes or is capable
                of being associated with, or could reasonably be linked, directly or indirectly, with You.
            </Paragraph>
            <Paragraph>Service refers to the Application or the Website or both.</Paragraph>
            <Paragraph>
                Service Provider means any natural or legal person who processes the data on behalf of the Company. It refers to third-party
                companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company,
                to perform services related to the Service or to assist the Company in analyzing how the Service is used.
            </Paragraph>
            <Paragraph>
                Usage Data refers to data collected automatically, either generated by the use of the Service or from the Service
                infrastructure itself (for example, the duration of a page visit).
            </Paragraph>
            <Paragraph>Website refers to CARGO MINDS, accessible from www.cargominds.ai</Paragraph>
            <Paragraph>
                You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such
                individual is accessing or using the Service, as applicable.
            </Paragraph>
            <Title>Collecting and Using Your Personal Data</Title>
            <Subtitle>Types of Data Collected</Subtitle>
            <Subtitle>Personal Data</Subtitle>
            <Paragraph>
                While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to
                contact or identify You. Personally identifiable information may include, but is not limited to:
            </Paragraph>
            <Paragraph>Email address</Paragraph>
            <Paragraph>First name and last name</Paragraph>
            <Paragraph>Phone number</Paragraph>
            <Paragraph>Address, State, Province, ZIP/Postal code, City</Paragraph>
            <Paragraph>Bank account information in order to pay for products and/or services within the Service</Paragraph>
            <Subtitle>Usage Data</Subtitle>
            <Paragraph>
                When You pay for a product and/or a service via bank transfer, We may ask You to provide information to facilitate this
                transaction and to verify Your identity. Such information may include, without limitation:
            </Paragraph>
            <Paragraph>Date of birth</Paragraph>
            <Paragraph>Passport or National ID card</Paragraph>
            <Paragraph>Bank card statement</Paragraph>
            <Paragraph>Other information linking You to an address</Paragraph>
            <Subtitle>Usage Data</Subtitle>
            <Paragraph>Usage Data is collected automatically when using the Service.</Paragraph>
            <Paragraph>
                Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser
                version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique
                device identifiers and other diagnostic data.
            </Paragraph>
            <Paragraph>
                When You access the Service by or through a mobile device, We may collect certain information automatically, including, but
                not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your
                mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.
            </Paragraph>
            <Paragraph>
                We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or
                through a mobile device.
            </Paragraph>
            <Subtitle>Information Collected while Using the Application</Subtitle>
            <Paragraph>
                While using Our Application, in order to provide features of Our Application, We may collect, with Your prior permission:
            </Paragraph>
            <Paragraph>Information regarding your location</Paragraph>
            <Paragraph>Pictures and other information from your Device's camera and photo library</Paragraph>
            <Paragraph>
                We use this information to provide features of Our Service, to improve and customize Our Service. The information may be
                uploaded to the Company's servers and/or a Service Provider's server or it may be simply stored on Your device.
            </Paragraph>
            <Paragraph>You can enable or disable access to this information at any time, through Your Device settings.</Paragraph>
            <Subtitle>Tracking Technologies and Cookies</Subtitle>
            <Paragraph>
                We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information.
                Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our
                Service. The technologies We use may include:
            </Paragraph>
            <Paragraph>
                Cookies or Browser Cookies. A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all
                Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some
                parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use
                Cookies.
            </Paragraph>
            <Paragraph>
                Web Beacons. Certain sections of our Service and our emails may contain small electronic files known as web beacons (also
                referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have
                visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a
                certain section and verifying system and server integrity).
            </Paragraph>
            <Paragraph>
                Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when
                You go offline, while Session Cookies are deleted as soon as You close Your web browser. You can learn more about cookies on
                TermsFeed website article.
            </Paragraph>
            <Paragraph>We use both Session and Persistent Cookies for the purposes set out below:</Paragraph>
            <Subtitle>Necessary / Essential Cookies</Subtitle>
            <Paragraph>Type: Session Cookies</Paragraph>
            <Paragraph>Administered by: Us</Paragraph>
            <Paragraph>
                Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use
                some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies,
                the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.
            </Paragraph>
            <Subtitle>Cookies Policy / Notice Acceptance Cookies</Subtitle>
            <Paragraph>Type: Persistent Cookies</Paragraph>
            <Paragraph>Administered by: Us</Paragraph>
            <Paragraph>Purpose: These Cookies identify if users have accepted the use of cookies on the Website.</Paragraph>
            <Subtitle>Functionality Cookies</Subtitle>
            <Paragraph>Type: Persistent Cookies</Paragraph>
            <Paragraph>Administered by: Us</Paragraph>
            <Paragraph>
                Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login
                details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid
                You having to re- enter your preferences every time You use the Website.
            </Paragraph>
            <Subtitle>Tracking and Performance Cookies</Subtitle>
            <Paragraph>Type: Persistent Cookies</Paragraph>
            <Paragraph>Administered by: Third-Parties</Paragraph>
            <Paragraph>
                Purpose: These Cookies are used to track information about traffic to the Website and how users use the Website. The
                information gathered via these Cookies may directly or indirectly identify you as an individual visitor. This is because the
                information collected is typically linked to a pseudonymous identifier associated with the device you use to access the
                Website. We may also use these Cookies to test new pages, features or new functionality of the Website to see how our users
                react to them.
            </Paragraph>
            <Paragraph>
                For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the
                Cookies section of our Privacy Policy.
            </Paragraph>
            <Subtitle>Use of Your Personal Data</Subtitle>
            <Paragraph>The Company may use Personal Data for the following purposes:</Paragraph>
            <Paragraph>To provide and maintain our Service, including to monitor the usage of our Service.</Paragraph>
            <Paragraph>
                To manage Your Account: to manage Your registration as a user of the Service. The Personal Data You provide can give You
                access to different functionalities of the Service that are available to You as a registered user.
            </Paragraph>
            <Paragraph>
                For the performance of a contract: the development, compliance and undertaking of the purchase contract for the products,
                items or services You have purchased or of any other contract with Us through the Service.
            </Paragraph>
            <Paragraph>
                To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such
                as a mobile application's push notifications regarding updates or informative communications related to the functionalities,
                products or contracted services, including the security updates, when necessary or reasonable for their implementation.
            </Paragraph>
            <Paragraph>
                To provide You with news, special offers and general information about other goods, services and events which we offer that
                are similar to those that you have already purchased or enquired about unless You have opted not to receive such
                information.
            </Paragraph>
            <Paragraph>To manage Your requests: To attend and manage Your requests to Us.</Paragraph>
            <Paragraph>
                To deliver targeted advertising to You: We may use Your information to develop and display content and advertising (and work
                with third-party vendors who do so) tailored to Your interests and/or location and to measure its effectiveness.
            </Paragraph>
            <Paragraph>
                For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring,
                reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part
                of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the
                assets transferred.
            </Paragraph>
            <Paragraph>
                For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage trends,
                determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services,
                marketing and your experience.
            </Paragraph>
            <Paragraph>We may share Your personal information in the following situations:</Paragraph>
            <Paragraph>
                With Service Providers: We may share Your personal information with Service Providers to monitor and analyze the use of our
                Service, to advertise on third party websites to You after You visited our Service, for payment processing, to contact You.
            </Paragraph>
            <Paragraph>
                For business transfers: We may share or transfer Your personal information in connection with, or during negotiations of,
                any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.
            </Paragraph>
            <Paragraph>
                With Affiliates: We may share Your information with Our affiliates, in which case we will require those affiliates to honor
                this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other
                companies that We control or that are under common control with Us.
            </Paragraph>
            <Paragraph>
                With business partners: We may share Your information with Our business partners to offer You certain products, services or
                promotions.
            </Paragraph>
            <Paragraph>
                With other users: when You share personal information or otherwise interact in the public areas with other users, such
                information may be viewed by all users and may be publicly distributed outside.
            </Paragraph>
            <Paragraph>With Your consent: We may disclose Your personal information for any other purpose with Your consent.</Paragraph>
            <Subtitle>Retention of Your Personal Data</Subtitle>
            <Paragraph>
                The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy.
                We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we
                are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and
                policies.
            </Paragraph>
            <Paragraph>
                The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter
                period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or
                We are legally obligated to retain this data for longer time periods.
            </Paragraph>
            <Subtitle>Transfer of Your Personal Data</Subtitle>
            <Paragraph>
                Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the
                parties involved in the processing are located. It means that this information may be transferred to - and maintained on -
                computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws
                may differ than those from Your jurisdiction.
            </Paragraph>
            <Paragraph>
                Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that
                transfer.
            </Paragraph>
            <Paragraph>
                The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with
                this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are
                adequate controls in place including the security of Your data and other personal information.
            </Paragraph>
            <Subtitle>Delete Your Personal Data</Subtitle>
            <Paragraph>
                You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.
            </Paragraph>
            <Paragraph>Our Service may give You the ability to delete certain information about You from within the Service.</Paragraph>
            <Paragraph>
                You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting
                the account settings section that allows you to manage Your personal information. You may also contact Us to request access
                to, correct, or delete any personal information that You have provided to Us.
            </Paragraph>
            <Paragraph>
                Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do
                so.
            </Paragraph>
            <Subtitle>Disclosure of Your Personal Data</Subtitle>
            <Subtitle>Business Transactions</Subtitle>
            <Paragraph>
                If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide
                notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
            </Paragraph>
            <Subtitle>Law enforcement</Subtitle>
            <Paragraph>
                Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in
                response to valid requests by public authorities (e.g. a court or a government agency).
            </Paragraph>
            <Subtitle>Other legal requirements</Subtitle>
            <Paragraph>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</Paragraph>
            <Paragraph>Comply with a legal obligation</Paragraph>
            <Paragraph>Protect and defend the rights or property of the Company</Paragraph>
            <Paragraph>Prevent or investigate possible wrongdoing in connection with the Service</Paragraph>
            <Paragraph>Protect the personal safety of Users of the Service or the public</Paragraph>
            <Paragraph>Protect against legal liability</Paragraph>
            <Subtitle>Security of Your Personal Data</Subtitle>
            <Paragraph>
                The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or
                method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal
                Data, We cannot guarantee its absolute security.
            </Paragraph>
            <Title>Detailed Information on the Processing of Your Personal Data</Title>
            <Paragraph>
                The Service Providers We use may have access to Your Personal Data. These third-party vendors collect, store, use, process
                and transfer information about Your activity on Our Service in accordance with their Privacy Policies.
            </Paragraph>
            <Subtitle>Analytics</Subtitle>
            <Paragraph>We may use third-party Service providers to monitor and analyze the use of our Service.</Paragraph>
            <Subtitle>Google Analytics</Subtitle>
            <Paragraph>
                Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data
                collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the
                collected data to contextualize and personalize the ads of its own advertising network.
            </Paragraph>
            <Paragraph>
                You can opt-out of having made your activity on the Service available to Google Analytics by installing the Google Analytics
                opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js and dc.js) from sharing
                information with Google Analytics about visits activity.
            </Paragraph>
            <Paragraph>
                You may opt-out of certain Google Analytics features through your mobile device settings, such as your device advertising
                settings or by following the instructions provided by Google in their Privacy Policy: https://policies.google.com/privacy
            </Paragraph>
            <Paragraph>
                For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page:
                https://policies.google.com/privacy
            </Paragraph>
            <Subtitle>Email Marketing</Subtitle>
            <Paragraph>
                We may use Your Personal Data to contact You with newsletters, marketing or promotional materials and other information that
                may be of interest to You. You may opt-out of receiving any, or all, of these communications from Us by following the
                unsubscribe link or instructions provided in any email We send or by contacting Us.
            </Paragraph>
            <Paragraph>We may use Email Marketing Service Providers to manage and send emails to You.</Paragraph>
            <Subtitle>Mailchimp</Subtitle>
            <Paragraph>Mailchimp is an email marketing sending service provided by The Rocket Science Group LLC.</Paragraph>
            <Paragraph>
                For more information on the privacy practices of Mailchimp, please visit their Privacy policy:
                https://mailchimp.com/legal/privacy/
            </Paragraph>
            <Subtitle>Payments</Subtitle>
            <Paragraph>
                We may provide paid products and/or services within the Service. In that case, we may use third-party services for payment
                processing (e.g. payment processors).
            </Paragraph>
            <Paragraph>
                We will not store or collect Your payment card details. That information is provided directly to Our third-party payment
                processors whose use of Your personal information is governed by their Privacy Policy. These payment processors adhere to
                the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa,
                Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information.
            </Paragraph>
            <Subtitle>Stripe</Subtitle>
            <Paragraph>Their Privacy Policy can be viewed at https://stripe.com/us/privacy</Paragraph>
            <Subtitle>PayPal</Subtitle>
            <Paragraph>Their Privacy Policy can be viewed at https://www.paypal.com/webapps/mpp/ua/privacy- full</Paragraph>
            <Paragraph>
                When You use Our Service to pay a product and/or service via bank transfer, We may ask You to provide information to
                facilitate this transaction and to verify Your identity.
            </Paragraph>
            <Subtitle>Behavioral Remarketing</Subtitle>
            <Paragraph>
                The Company uses remarketing services to advertise to You after You accessed or visited our Service. We and Our third-party
                vendors use cookies and non-cookie technologies to help Us recognize Your Device and understand how You use our Service so
                that We can improve our Service to reflect Your interests and serve You advertisements that are likely to be of more
                interest to You.
            </Paragraph>
            <Paragraph>
                These third-party vendors collect, store, use, process and transfer information about Your activity on Our Service in
                accordance with their Privacy Policies and to enable Us to:
            </Paragraph>
            <Subtitle>Measure and analyze traffic and browsing activity on Our Service</Subtitle>
            <Paragraph>Show advertisements for our products and/or services to You on third-party websites or apps</Paragraph>
            <Subtitle>Measure and analyze the performance of Our advertising campaigns</Subtitle>
            <Paragraph>
                Some of these third-party vendors may use non-cookie technologies that may not be impacted by browser settings that block
                cookies. Your browser may not permit You to block such technologies. You can use the following third-party tools to decline
                the collection and use of information for the purpose of serving You interest-based advertising:
            </Paragraph>
            <Paragraph>The NAI's opt-out platform: http://www.networkadvertising.org/choices/</Paragraph>
            <Paragraph>The EDAA's opt-out platform http://www.youronlinechoices.com/</Paragraph>
            <Paragraph>The DAA's opt-out platform: http://optout.aboutads.info/?c=2&lang=EN</Paragraph>
            <Paragraph>
                You may opt-out of all personalized advertising by enabling privacy features on Your mobile device such as Limit Ad Tracking
                (iOS) and Opt Out of Ads Personalization (Android). See Your mobile device Help system for more information.
            </Paragraph>
            <Paragraph>
                We may share information, such as hashed email addresses (if available) or other online identifiers collected on Our Service
                with these third-party vendors. This allows Our third- party vendors to recognize and deliver You ads across devices and
                browsers. To read more about the technologies used by these third-party vendors and their cross-device capabilities please
                refer to the Privacy Policy of each vendor listed below.
            </Paragraph>
            <Paragraph>The third-party vendors We use are:</Paragraph>
            <Subtitle>Google Ads (AdWords)</Subtitle>
            <Paragraph>Google Ads (AdWords) remarketing service is provided by Google Inc.</Paragraph>
            <Paragraph>
                You can opt-out of Google Analytics for Display Advertising and customise the Google Display Network ads by visiting the
                Google Ads Settings page: http://www.google.com/settings/ads
            </Paragraph>
            <Paragraph>
                Google also recommends installing the Google Analytics Opt-out Browser Add-on - https://tools.google.com/dlpage/gaoptout -
                for your web browser. Google Analytics Opt- out Browser Add-on provides visitors with the ability to prevent their data from
                being collected and used by Google Analytics.
            </Paragraph>
            <Paragraph>
                For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page:
                https://policies.google.com/privacy
            </Paragraph>
            <Subtitle>Facebook</Subtitle>
            <Paragraph>Facebook remarketing service is provided by Facebook Inc.</Paragraph>
            <Paragraph>
                You can learn more about interest-based advertising from Facebook by visiting this page:
                https://www.facebook.com/help/516147308587266
            </Paragraph>
            <Paragraph>
                To opt-out from Facebook's interest-based ads, follow these instructions from Facebook:
                https://www.facebook.com/help/568137493302217
            </Paragraph>
            <Paragraph>
                Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the Digital Advertising
                Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in
                the USA http://www.aboutads.info/choices/, the Digital Advertising Alliance of Canada in Canada http://youradchoices.ca/ or
                the European Interactive Digital Advertising Alliance in Europe http://www.youronlinechoices.eu/, or opt-out using your
                mobile device settings.
            </Paragraph>
            <Paragraph>
                For more information on the privacy practices of Facebook, please visit Facebook's Data Policy:
                https://www.facebook.com/privacy/explanation
            </Paragraph>
            <Title>CCPA/CPRA Privacy Notice</Title>
            <Paragraph>
                This privacy notice section for California residents supplements the information contained in Our Privacy Policy and it
                applies solely to all visitors, users, and others who reside in the State of California.
            </Paragraph>
            <Subtitle>Categories of Personal Information Collected</Subtitle>
            <Paragraph>
                We collect information that identifies, relates to, describes, references, is capable of being associated with, or could
                reasonably be linked, directly or indirectly, with a particular Consumer or Device. The following is a list of categories of
                personal information which we may collect or may have been collected from California residents within the last twelve (12)
                months.
            </Paragraph>
            <Paragraph>
                Please note that the categories and examples provided in the list below are those defined in the CCPA/CPRA. This does not
                mean that all examples of that category of personal information were in fact collected by Us, but reflects our good faith
                belief to the best of Our knowledge that some of that information from the applicable category may be and may have been
                collected. For example, certain categories of personal information would only be collected if You provided such personal
                information directly to Us.
            </Paragraph>
            <Subtitle>Category A: Identifiers.</Subtitle>
            <Paragraph>
                Examples: A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address,
                email address, account name, driver's license number, passport number, or other similar identifiers.
            </Paragraph>
            <Paragraph>Collected: Yes.</Paragraph>
            <Subtitle>
                Category B: Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)).
            </Subtitle>
            <Paragraph>
                Examples: A name, signature, Social Security number, physical characteristics or description, address, telephone number,
                passport number, driver's license or state identification card number, insurance policy number, education, employment,
                employment history, bank account number, credit card number, debit card number, or any other financial information, medical
                information, or health insurance information. Some personal information included in this category may overlap with other
                categories.
            </Paragraph>
            <Paragraph>Collected: Yes.</Paragraph>
            <Subtitle>Category C: Protected classification characteristics under California or federal law.</Subtitle>
            <Paragraph>
                Examples: Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status,
                medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or
                childbirth and related medical conditions), sexual orientation, veteran or military status, genetic information (including
                familial genetic information).
            </Paragraph>
            <Paragraph>Collected: No.</Paragraph>
            <Subtitle>Category D: Commercial information.</Subtitle>
            <Paragraph>Examples: Records and history of products or services purchased or considered.</Paragraph>
            <Paragraph>Collected: Yes.</Paragraph>
            <Subtitle>Category E: Biometric information.</Subtitle>
            <Paragraph>
                Examples: Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a
                template or other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina
                scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data.
            </Paragraph>
            <Paragraph>Collected: No.</Paragraph>
            <Subtitle>Category F: Internet or other similar network activity.</Subtitle>
            <Paragraph>Examples: Interaction with our Service or advertisement.</Paragraph>
            <Paragraph>Collected: Yes.</Paragraph>
            <Subtitle>Category G: Geolocation data</Subtitle>
            <Paragraph>Examples: Approximate physical location.</Paragraph>
            <Paragraph>Collected: Yes.</Paragraph>
            <Subtitle>Category H: Sensory data.</Subtitle>
            <Paragraph>Examples: Audio, electronic, visual, thermal, olfactory, or similar information.</Paragraph>
            <Paragraph>Collected: No.</Paragraph>
            <Subtitle>Category I: Professional or employment-related information.</Subtitle>
            <Paragraph>Examples: Current or past job history or performance evaluations.</Paragraph>
            <Paragraph>Collected: No.</Paragraph>
            <Subtitle>
                Category J: Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34
                C.F.R. Part 99)).
            </Subtitle>
            <Paragraph>
                Examples: Education records directly related to a student maintained by an educational institution or party acting on its
                behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial
                information, or student disciplinary records.
            </Paragraph>
            <Paragraph>Collected: No.</Paragraph>
            <Subtitle>Category K: Inferences drawn from other personal information.</Subtitle>
            <Paragraph>
                Examples: Profile reflecting a person's preferences, characteristics, psychological trends, predispositions, behavior,
                attitudes, intelligence, abilities, and aptitudes.
            </Paragraph>
            <Paragraph>Collected: No.</Paragraph>
            <Subtitle>Category L: Sensitive personal information.</Subtitle>
            <Paragraph>Examples: Account login and password information, geolocation data.</Paragraph>
            <Paragraph>Collected: Yes.</Paragraph>
            <Paragraph>Under CCPA/CPRA, personal information does not include:</Paragraph>
            <Paragraph>Publicly available information from government records</Paragraph>
            <Paragraph>Deidentified or aggregated consumer information</Paragraph>
            <Paragraph>Information excluded from the CCPA/CPRA's scope, such as:</Paragraph>
            <Paragraph>
                Health or medical information covered by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and the
                California Confidentiality of Medical Information Act (CMIA) or clinical trial data
            </Paragraph>
            <Paragraph>
                Personal Information covered by certain sector-specific privacy laws, including the Fair Credit Reporting Act (FRCA), the
                Gramm-Leach-Bliley Act (GLBA) or California Financial Information Privacy Act (FIPA), and the Driver's Privacy Protection
                Act of 1994
            </Paragraph>
            <Subtitle>Sources of Personal Information</Subtitle>
            <Paragraph>We obtain the categories of personal information listed above from the following categories of sources:</Paragraph>
            <Paragraph>
                Directly from You. For example, from the forms You complete on our Service, preferences You express or provide through our
                Service, or from Your purchases on our Service.
            </Paragraph>
            <Paragraph>Indirectly from You. For example, from observing Your activity on our Service.</Paragraph>
            <Paragraph>
                Automatically from You. For example, through cookies We or our Service Providers set on Your Device as You navigate through
                our Service.
            </Paragraph>
            <Paragraph>
                From Service Providers. For example, third-party vendors to monitor and analyze the use of our Service, third-party vendors
                to deliver targeted advertising to You, third-party vendors for payment processing, or other third-party vendors that We use
                to provide the Service to You.
            </Paragraph>
            <Subtitle>Use of Personal Information</Subtitle>
            <Paragraph>
                We may use or disclose personal information We collect for "business purposes" or "commercial purposes" (as defined under
                the CCPA/CPRA), which may include the following examples:
            </Paragraph>
            <Paragraph>To operate our Service and provide You with Our Service.</Paragraph>
            <Paragraph>
                To provide You with support and to respond to Your inquiries, including to investigate and address Your concerns and monitor
                and improve our Service.
            </Paragraph>
            <Paragraph>
                To fulfill or meet the reason You provided the information. For example, if You share Your contact information to ask a
                question about our Service, We will use that personal information to respond to Your inquiry. If You provide Your personal
                information to purchase a product or service, We will use that information to process Your payment and facilitate delivery.
            </Paragraph>
            <Paragraph>
                To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations.
            </Paragraph>
            <Paragraph>As described to You when collecting Your personal information or as otherwise set forth in the CCPA/CPRA.</Paragraph>
            <Paragraph>For internal administrative and auditing purposes.</Paragraph>
            <Paragraph>
                To detect security incidents and protect against malicious, deceptive, fraudulent or illegal activity, including, when
                necessary, to prosecute those responsible for such activities.
            </Paragraph>
            <Paragraph>Other one-time uses.</Paragraph>
            <Paragraph>
                Please note that the examples provided above are illustrative and not intended to be exhaustive. For more details on how we
                use this information, please refer to the "Use of Your Personal Data" section.
            </Paragraph>
            <Paragraph>
                If We decide to collect additional categories of personal information or use the personal information We collected for
                materially different, unrelated, or incompatible purposes We will update this Privacy Policy.
            </Paragraph>
            <Subtitle>Disclosure of Personal Information</Subtitle>
            <Paragraph>
                We may use or disclose and may have used or disclosed in the last twelve (12) months the following categories of personal
                information for business or commercial purposes:
            </Paragraph>
            <Paragraph>Category A: Identifiers</Paragraph>
            <Paragraph>
                Category B: Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e))
            </Paragraph>
            <Paragraph>Category D: Commercial information</Paragraph>
            <Paragraph>Category F: Internet or other similar network activity</Paragraph>
            <Paragraph>Category G: Geolocation data</Paragraph>
            <Paragraph>Category L: Sensitive personal information</Paragraph>
            <Paragraph>
                Please note that the categories listed above are those defined in the CCPA/CPRA. This does not mean that all examples of
                that category of personal information were in fact disclosed, but reflects our good faith belief to the best of our
                knowledge that some of that information from the applicable category may be and may have been disclosed.
            </Paragraph>
            <Paragraph>
                When We disclose personal information for a business purpose or a commercial purpose, We enter a contract that describes the
                purpose and requires the recipient to both keep that personal information confidential and not use it for any purpose except
                performing the contract.
            </Paragraph>
            <Subtitle>Share of Personal Information</Subtitle>
            <Paragraph>
                We may share, and have shared in the last twelve (12) months, Your personal information identified in the above categories
                with the following categories of third parties:
            </Paragraph>
            <Paragraph>Service Providers</Paragraph>
            <Paragraph>Payment processors</Paragraph>
            <Paragraph>Our affiliates</Paragraph>
            <Paragraph>Our business partners</Paragraph>
            <Paragraph>
                Third party vendors to whom You or Your agents authorize Us to disclose Your personal information in connection with
                products or services We provide to You
            </Paragraph>
            <Subtitle>Sale of Personal Information</Subtitle>
            <Paragraph>
                As defined in the CCPA/CPRA, "sell" and "sale" mean selling, renting, releasing, disclosing, disseminating, making
                available, transferring, or otherwise communicating orally, in writing, or by electronic or other means, a Consumer's
                personal information by the Business to a third party for valuable consideration. This means that We may have received some
                kind of benefit in return for sharing personal information, but not necessarily a monetary benefit.
            </Paragraph>
            <Paragraph>
                We do not sell personal information as the term sell is commonly understood. We do allow Service Providers to use Your
                personal information for the business purposes described in Our Privacy Policy, for activities such as advertising,
                marketing, and analytics, and these may be deemed a aale under CCPA/CPRA.
            </Paragraph>
            <Paragraph>
                We may sell and may have sold in the last twelve (12) months the following categories of personal information:
            </Paragraph>
            <Paragraph>Category A: Identifiers</Paragraph>
            <Paragraph>
                Category B: Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e))
            </Paragraph>
            <Paragraph>Category D: Commercial information</Paragraph>
            <Paragraph>Category F: Internet or other similar network activity</Paragraph>
            <Paragraph>Category G: Geolocation data</Paragraph>
            <Paragraph>Category L: Sensitive personal information</Paragraph>
            <Paragraph>
                Please note that the categories listed above are those defined in the CCPA/CPRA. This does not mean that all examples of
                that category of personal information were in fact sold, but reflects our good faith belief to the best of Our knowledge
                that some of that information from the applicable category may be and may have been shared for value in return.
            </Paragraph>
            <Paragraph>Sale of Personal Information of Minors Under 16 Years of Age</Paragraph>
            <Paragraph>
                We do not knowingly collect personal information from minors under the age of 16 through our Service, although certain third
                party websites that we link to may do so. These third- party websites have their own terms of use and privacy policies and
                We encourage parents and legal guardians to monitor their children's Internet usage and instruct their children to never
                provide information on other websites without their permission.
            </Paragraph>
            <Paragraph>
                We do not sell the personal information of Consumers We actually know are less than 16 years of age, unless We receive
                affirmative authorization (the "right to opt-in") from either the Consumer who is between 13 and 16 years of age, or the
                parent or guardian of a Consumer less than 13 years of age. Consumers who opt-in to the sale of personal information may
                opt-out of future sales at any time. To exercise the right to opt-out, You (or Your authorized representative) may submit a
                request to Us by contacting Us.
            </Paragraph>
            <Paragraph>
                If You have reason to believe that a child under the age of 13 (or 16) has provided Us with personal information, please
                contact Us with sufficient detail to enable Us to delete that information.
            </Paragraph>
            <Subtitle>Your Rights under the CCPA/CPRA</Subtitle>
            <Paragraph>
                The CCPA/CPRA provides California residents with specific rights regarding their personal information. If You are a resident
                of California, You have the following rights:
            </Paragraph>
            <Paragraph>
                The right to notice. You have the right to be notified which categories of Personal Data are being collected and the
                purposes for which the Personal Data is being used.
            </Paragraph>
            <Paragraph>
                The right to know/access. Under CCPA/CPRA, You have the right to request that We disclose information to You about Our
                collection, use, sale, disclosure for business purposes and share of personal information. Once We receive and confirm Your
                request, We will disclose to You:
            </Paragraph>
            <Paragraph>The categories of personal information We collected about You</Paragraph>
            <Paragraph>The categories of sources for the personal information We collected about You</Paragraph>
            <Paragraph>Our business or commercial purposes for collecting or selling that personal information</Paragraph>
            <Paragraph>The categories of third parties with whom We share that personal information</Paragraph>
            <Paragraph>The specific pieces of personal information We collected about You</Paragraph>
            <Paragraph>
                If we sold Your personal information or disclosed Your personal information for a business purpose, We will disclose to You:
            </Paragraph>
            <Paragraph>The categories of personal information categories sold</Paragraph>
            <Paragraph>The categories of personal information categories disclosed</Paragraph>
            <Paragraph>
                The right to say no to the sale or sharing of Personal Data (opt-out). You have the right to direct Us to not sell Your
                personal information. To submit an opt-out request, please see the "Do Not Sell My Personal Information" section or contact
                Us.
            </Paragraph>
            <Paragraph>
                The right to correct Personal Data. You have the right to correct or rectify any any inaccurate personal information about
                You that We collected. Once We receive and confirm Your request, We will use commercially reasonable efforts to correct (and
                direct our Service Providers to correct) Your personal information, unless an exception applies.
            </Paragraph>
            <Paragraph>
                The right to limit use and disclosure of sensitive Personal Data. You have the right to request to limit the use or
                disclosure of certain sensitive personal information We collected about You, unless an exception applies. To submit, please
                see the "Limit the Use or Disclosure of My Sensitive Personal Information" section or contact Us.
            </Paragraph>
            <Paragraph>
                The right to delete Personal Data. You have the right to request the deletion of Your Personal Data under certain
                circumstances, subject to certain exceptions. Once We receive and confirm Your request, We will delete (and direct Our
                Service Providers to delete) Your personal information from our records, unless an exception applies. We may deny Your
                deletion request if retaining the information is necessary for Us or Our Service Providers to:
            </Paragraph>
            <Paragraph>
                Complete the transaction for which We collected the personal information, provide a good or service that You requested, take
                actions reasonably anticipated within the context of our ongoing business relationship with You, or otherwise perform our
                contract with You.
            </Paragraph>
            <Paragraph>
                Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those
                responsible for such activities.
            </Paragraph>
            <Paragraph>Debug products to identify and repair errors that impair existing intended functionality.</Paragraph>
            <Paragraph>
                Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or exercise another right
                provided for by law.
            </Paragraph>
            <Paragraph>Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 et. seq.).</Paragraph>
            <Paragraph>
                Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all
                other applicable ethics and privacy laws, when the information's deletion may likely render impossible or seriously impair
                the research's achievement, if You previously provided informed consent.
            </Paragraph>
            <Paragraph>
                Enable solely internal uses that are reasonably aligned with consumer expectations based on Your relationship with Us.
            </Paragraph>
            <Paragraph>Comply with a legal obligation.</Paragraph>
            <Paragraph>
                Make other internal and lawful uses of that information that are compatible with the context in which You provided it.
            </Paragraph>
            <Paragraph>
                The right not to be discriminated against. You have the right not to be discriminated against for exercising any of Your
                consumer's rights, including by:
            </Paragraph>
            <Subtitle>Denying goods or services to You</Subtitle>
            <Paragraph>
                Charging different prices or rates for goods or services, including the use of discounts or other benefits or imposing
                penalties
            </Paragraph>
            <Paragraph>Providing a different level or quality of goods or services to You</Paragraph>
            <Paragraph>
                Suggesting that You will receive a different price or rate for goods or services or a different level or quality of goods or
                services
            </Paragraph>
            <Subtitle>Exercising Your CCPA/CPRA Data Protection Rights</Subtitle>
            <Paragraph>
                Please see the "Do Not Sell My Personal Information" section and "Limit the Use or Disclosure of My Sensitive Personal
                Information" section for more information on how to opt out and limit the use of sensitive information collected.
            </Paragraph>
            <Paragraph>
                Additionally, in order to exercise any of Your rights under the CCPA/CPRA, and if You are a California resident, You can
                contact Us:
            </Paragraph>
            <Paragraph>By email office@cargominds.ai</Paragraph>
            <Paragraph>
                Only You, or a person registered with the California Secretary of State that You authorize to act on Your behalf, may make a
                verifiable request related to Your personal information.
            </Paragraph>
            <Paragraph>Your request to Us must:</Paragraph>
            <Paragraph>
                Provide sufficient information that allows Us to reasonably verify You are the person about whom We collected personal
                information or an authorized representative
            </Paragraph>
            <Paragraph>
                Describe Your request with sufficient detail that allows Us to properly understand, evaluate, and respond to it
            </Paragraph>
            <Paragraph>We cannot respond to Your request or provide You with the required information if We cannot:</Paragraph>
            <Paragraph>Verify Your identity or authority to make the request</Paragraph>
            <Paragraph>And confirm that the personal information relates to You</Paragraph>
            <Paragraph>
                We will disclose and deliver the required information free of charge within 45 days of receiving Your verifiable request.
                The time period to provide the required information may be extended once by an additional 45 days when reasonably necessary
                and with prior notice.
            </Paragraph>
            <Paragraph>
                Any disclosures We provide will only cover the 12-month period preceding the verifiable request's receipt.
            </Paragraph>
            <Paragraph>
                For data portability requests, We will select a format to provide Your personal information that is readily usable and
                should allow You to transmit the information from one entity to another entity without hindrance.
            </Paragraph>
            <Subtitle>Do Not Sell My Personal Information</Subtitle>
            <Paragraph>
                As defined in the CCPA/CPRA, "sell" and "sale" mean selling, renting, releasing, disclosing, disseminating, making
                available, transferring, or otherwise communicating orally, in writing, or by electronic or other means, a Consumer's
                personal information by the Business to a third party for valuable consideration. This means that We may have received some
                kind of benefit in return for sharing personal information, but not necessarily a monetary benefit.
            </Paragraph>
            <Paragraph>
                We do not sell personal information as the term sell is commonly understood. We do allow Service Providers to use Your
                personal information for the business purposes described in Our Privacy Policy, for activities such as advertising,
                marketing, and analytics, and these may be deemed a sale under CCPA/CPRA.
            </Paragraph>
            <Paragraph>
                You have the right to opt-out of the sale of Your personal information. Once We receive and confirm a verifiable consumer
                request from You, we will stop selling Your personal information. To exercise Your right to opt-out, please contact Us.
            </Paragraph>
            <Paragraph>
                The Service Providers we partner with (for example, our analytics or advertising partners) may use technology on the Service
                that sells personal information as defined by the CCPA/CPRA law. If you wish to opt out of the use of Your personal
                information for interest- based advertising purposes and these potential sales as defined under CCPA/CPRA law, you may do so
                by following the instructions below.
            </Paragraph>
            <Paragraph>
                Please note that any opt out is specific to the browser You use. You may need to opt out on every browser that You use.
            </Paragraph>
            <Subtitle>Website</Subtitle>
            <Paragraph>
                If applicable, click "Privacy Preferences", "Update Privacy Preferences" or "Do Not Sell My Personal Information" buttons
                listed on the Service to review your privacy preferences and opt out of cookies and other technologies that We may use.
                Please note that You will need to opt out from each browser that You use to access the Service.
            </Paragraph>
            <Paragraph>
                Additionally, You can opt out of receiving ads that are personalized as served by our Service Providers by following our
                instructions presented on the Service:
            </Paragraph>
            <Paragraph>The NAI's opt-out platform: http://www.networkadvertising.org/choices/</Paragraph>
            <Paragraph>The EDAA's opt-out platform http://www.youronlinechoices.com/</Paragraph>
            <Paragraph>The DAA's opt-out platform: http://optout.aboutads.info/?c=2&lang=EN</Paragraph>
            <Paragraph>
                The opt out will place a cookie on Your computer that is unique to the browser You use to opt out. If you change browsers or
                delete the cookies saved by your browser, You will need to opt out again.
            </Paragraph>
            <Subtitle>Mobile Devices</Subtitle>
            <Paragraph>
                Your mobile device may give You the ability to opt out of the use of information about the apps You use in order to serve
                You ads that are targeted to Your interests:
            </Paragraph>
            <Paragraph>"Opt out of Interest-Based Ads" or "Opt out of Ads Personalization" on Android devices</Paragraph>
            <Paragraph>"Limit Ad Tracking" on iOS devices</Paragraph>
            <Paragraph>
                You can also stop the collection of location information from Your mobile device by changing the preferences on Your mobile
                device.
            </Paragraph>
            <Subtitle>Limit the Use or Disclosure of My Sensitive Personal Information</Subtitle>
            <Paragraph>
                If You are a California resident, You have the right to limit the use and disclosure of Your sensitive personal information
                to that use which is necessary to perform the services or provide the goods reasonably expected by an average Consumer who
                requests such services or goods.
            </Paragraph>
            <Paragraph>
                We collect, use and disclose sensitive personal information in ways that are necessary to provide the Service. For more
                information on how We use Your personal information, please see the "Use of Your Personal Data" section or contact us.
            </Paragraph>
            <Title>"Do Not Track" Policy as Required by California Online Privacy Protection Act (CalOPPA)</Title>
            <Paragraph>Our Service does not respond to Do Not Track signals.</Paragraph>
            <Paragraph>
                However, some third party websites do keep track of Your browsing activities. If You are visiting such websites, You can set
                Your preferences in Your web browser to inform websites that You do not want to be tracked. You can enable or disable DNT by
                visiting the preferences or settings page of Your web browser.
            </Paragraph>
            <Title>Your California Privacy Rights (California's Shine the Light law)</Title>
            <Paragraph>
                Under California Civil Code Section 1798 (California's Shine the Light law), California residents with an established
                business relationship with us can request information once a year about sharing their Personal Data with third parties for
                the third parties' direct marketing purposes.
            </Paragraph>
            <Paragraph>
                If you'd like to request more information under the California Shine the Light law, and if You are a California resident,
                You can contact Us using the contact information provided below.
            </Paragraph>
            <Title>California Privacy Rights for Minor Users (California Business and Professions Code Section 22581)</Title>
            <Paragraph>
                California Business and Professions Code Section 22581 allows California residents under the age of 18 who are registered
                users of online sites, services or applications to request and obtain removal of content or information they have publicly
                posted.
            </Paragraph>
            <Paragraph>
                To request removal of such data, and if You are a California resident, You can contact Us using the contact information
                provided below, and include the email address associated with Your account.
            </Paragraph>
            <Paragraph>
                Be aware that Your request does not guarantee complete or comprehensive removal of content or information posted online and
                that the law may not permit or require removal in certain circumstances.
            </Paragraph>
            <Title>Children's Privacy</Title>
            <Paragraph>
                Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information
                from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with
                Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13
                without verification of parental consent, We take steps to remove that information from Our servers.
            </Paragraph>
            <Paragraph>
                If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a
                parent, We may require Your parent's consent before We collect and use that information.
            </Paragraph>
            <Title>Links to Other Websites</Title>
            <Paragraph>
                Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be
                directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
            </Paragraph>
            <Paragraph>
                We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites
                or services.
            </Paragraph>
            <Title>Use of Artificial Intelligence (AI) and Machine Learning</Title>
            <Paragraph>
                CARGOMINDS uses artificial intelligence (AI) and machine learning (ML) technologies to enhance select features of our
                services, including pricing estimates, destination recommendations, and document processing. These tools help optimize
                workflows, support operational efficiency, and improve predictive accuracy for our customers.
            </Paragraph>
            <Paragraph>
                We do not use external AI systems in any way that publicly exposes your personal information. However, internally, we may
                utilize Azure AI services-including models powered by OpenAI GPT-4-for document parsing tasks, such as extracting shipment
                data from uploaded PDFs. These models operate under a fixed prompt structure, and the data returned is formatted for
                internal system use only. End-users do not directly interact with or influence these AI tools.
            </Paragraph>
            <Subtitle>Data Handling for AI Training and Predictions</Subtitle>
            <Paragraph>
                To train and improve the performance of our internal AI models, we may use data such as rate confirmations, invoices, bills
                of lading, and load records. Any personally identifiable information-such as driver names-is converted to anonymized or
                pseudonymized forms before use. We do not train AI models on user-generated data like messages or inputs from dispatcher
                activities within the application.
            </Paragraph>
            <Paragraph>
                Our models may be retrained on a regular basis using shipment-related data from customer Transportation Management Systems
                (TMS). Data that is aggregated and anonymized may be retained indefinitely for product improvement, analytics, and fraud
                prevention. This information cannot be traced back to individual users and is excluded from deletion requests under current
                U.S. privacy laws.
            </Paragraph>
            <Subtitle>Profiling and Automated Decision-Making</Subtitle>
            <Paragraph>
                Our platform may deliver AI-generated outputs, including load price estimates and destination recommendations. These
                features are intended to support, not replace, human decision-making and do not determine contract pricing or access to
                services. While users currently cannot opt out of these predictive features, they are clearly labeled and are offered only
                as decision-support tools. CARGOMINDS does not engage in automated decision-making that produces legal or similarly
                significant effects under U.S. privacy regulations.
            </Paragraph>
            <Subtitle>Transparency and Explainability</Subtitle>
            <Paragraph>
                Certain recommendations (e.g., next destinations) are based on fixed, rules-based systems that are explainable and
                auditable. Other predictions, such as price forecasting, are based on more complex models. While not every AI output can be
                individually explained, we are working to improve user understanding and will clearly indicate where AI is used.
            </Paragraph>
            <Paragraph>
                Due to proprietary system designs and confidentiality obligations, detailed model architecture and training data specifics
                may not be disclosed to the public.
            </Paragraph>
            <Subtitle>Data Rights and Limitations</Subtitle>
            <Paragraph>
                Users may request the deletion of their personal information at any time as outlined in this Privacy Policy. However,
                anonymized and aggregated data used in AI training is excluded from deletion because it cannot reasonably be linked to any
                individual user and is essential to ongoing model development.
            </Paragraph>
            <Paragraph>
                Currently, users do not have direct access to view, modify, or download the specific data used in predictive modeling. As of
                now, CARGOMINDS does not perform formal AI risk assessments (e.g., algorithmic impact assessments), but we maintain
                safeguards through our cloud provider (Azure AI) to mitigate the risk of harmful or biased outputs.
            </Paragraph>
            <Paragraph>
                We will notify users of any material changes to our AI practices. As U.S. laws and regulations around artificial
                intelligence evolve, we will continue to update our practices to remain compliant with federal and state-level guidance.
            </Paragraph>
            <Title>Changes to this Privacy Policy</Title>
            <Paragraph>
                We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on
                this page.
            </Paragraph>
            <Paragraph>
                We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update
                the "Last updated" date at the top of this Privacy Policy.
            </Paragraph>
            <Paragraph>
                You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective
                when they are posted on this page.
            </Paragraph>
            <Subtitle>Contact Us</Subtitle>
            <Paragraph>If you have any questions about this Privacy Policy, You can contact us:</Paragraph>
            <Paragraph>By email: office@cargominds.ai</Paragraph>
            <Title>SMS Privacy Policy</Title>
            <Paragraph>Effective Date: January 2023</Paragraph>
            <Paragraph>
                This SMS Privacy Policy outlines important information regarding the use of Short Message Service (SMS) communications
                provided by CARGO MINDS. to its users. By opting in to receive SMS messages from CARGO MINDS you acknowledge and agree to
                the terms and conditions outlined in this policy.
            </Paragraph>
            <Subtitle>Message Frequency:</Subtitle>
            <Paragraph>Subscribers can expect to receive SMS messages from CARGO MINDS approximately 2-4 messages per month.</Paragraph>
            <Paragraph>Message frequency may vary based on the type of content, promotions, or updates being sent.</Paragraph>
            <Subtitle>Opt-Out Information:</Subtitle>
            <Paragraph>You have the right to opt-out of receiving SMS messages from CARGO MINDS at any time.</Paragraph>
            <Paragraph>
                To opt out, please reply to any SMS message from us with the word “STOP” or any other keyword we specify for opt-out.
            </Paragraph>
            <Paragraph>You can also opt out by contacting us at:</Paragraph>
            <Paragraph>Email: office@cargominds.ai</Paragraph>
            <Subtitle>Message and Data Rates:</Subtitle>
            <Paragraph>
                Standard message and data rates may apply to the SMS messages sent and received, depending on your mobile carrier and plan.
            </Paragraph>
            <Paragraph>
                If you have any concerns about the cost of receiving SMS messages, please contact your mobile service provider.
            </Paragraph>
            <Subtitle>Privacy and Data Usage:</Subtitle>
            <Paragraph>
                CARGO MINDS respects your privacy and will not share or sell your phone number or personal information with any third
                parties.
            </Paragraph>
            <Paragraph>Please refer to our full Privacy Policy for more information on how we handle your data.</Paragraph>
            <Subtitle>Security:</Subtitle>
            <Paragraph>
                We take the security of your information seriously and use industry-standard measures to protect your personal data.
            </Paragraph>
            <Paragraph>
                However, please be aware that while we take all reasonable steps to secure your data, no method of transmission over the
                internet or method of electronic storage is entirely secure.
            </Paragraph>
            <Subtitle>Changes to this Policy:</Subtitle>
            <Paragraph>
                CARGO MINDS reserves the right to update or change this SMS Privacy Policy at any time. Any changes will be posted on our
                website, and, if applicable, we will notify you via SMS. It is your responsibility to review this policy periodically to
                ensure you are aware of any updates.
            </Paragraph>
            <Subtitle>Contact Us:</Subtitle>
            <Paragraph>If you have any questions, concerns, or requests regarding this SMS Privacy Policy, please contact us at:</Paragraph>
            <Paragraph>office@cargominds.ai</Paragraph>
            <Subtitle>Acceptance:</Subtitle>
            <Paragraph>
                By opting in to receive SMS messages from CARGO MINDS, you indicate your acceptance of this SMS Privacy Policy.
            </Paragraph>
            <Paragraph>
                CARGO MINDS may provide additional SMS Terms & Conditions that supplement this policy. It’s important to review and comply
                with those terms as well.
            </Paragraph>
        </div>
    );
};
